import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { LatestNewsCollection } from '@/modules/news/models/news-collection.model'
import { AdminLatestNewsServices } from '@/modules/news/services/admin-news.service'

@vservice()
export class NewsCreateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminLatestNewsServices
  ) {
  }

  isSuccess = false
  isLoading = false

  execute(data: LatestNewsCollection) {
    return this.service.create(data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}